import { withStyles } from '@material-ui/core';
import CardIcon from './CardIcon';
import styles from './styles';

export default withStyles(styles)(CardIcon);
